import { IntlShape } from 'react-intl';
import * as Yup from 'yup';

import {
  ExtendMetricObject,
  FollowedSecurityPolicyOptionsObject,
  VerticalObject,
} from '../../../../api/CoachingForm/schema';
import {
  ContactDetails,
  GoodRecommendationOptionsObject as validationSchemaForRecommendationFeedback,
  InaccurateContactRecommendationReasonsObject,
} from '../../../../api/CoachingNotes/schema';

const validationSchemaForNoRecommendation = (
  intl: IntlShape
): Yup.ObjectSchema => {
  const messages = {
    goodRecommendation: {
      required: intl.formatMessage({
        id: 'cs_perfportal_contact_recom_validate_required_good_recom',
        defaultMessage: 'This field is required when entering contact notes',
      }),
    },
    generic: {
      oneOf: intl.formatMessage({
        id: 'cs_perfportal_form_generic_validate_choose_option_from_dropdown',
        defaultMessage: 'Choose an available option from the dropdown',
      }),
    },
  };

  return Yup.object<ContactDetails>().shape({
    goodRecommendation: Yup.mixed().oneOf(
      [null, ...Object.values(validationSchemaForRecommendationFeedback)],
      messages.goodRecommendation.required
    ),
    uncoachableReason: Yup.mixed().oneOf(
      [null, ...Object.values(InaccurateContactRecommendationReasonsObject)],
      messages.generic.oneOf
    ),
  });
};

export default validationSchemaForNoRecommendation;
